<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <router-view></router-view>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: [
    'status',
  ],
  data() {
    return {
      breadcrumb: [
        { name: "维保管理", path: `/fix/repairer` },
        { name: "维修商管理", path: `/fix/repairer` },
      ],
      menuIndex: '',
      menu: [],
      list: ['在用', '停用'],
    };
  },
  computed: {
    ...mapState([
      'store'
    ]),
  },
  methods: {
    setRoute() {
      this.list.map((v, i) => {
        const o = {
          name: v,
          path: `/fix/repairer/list/${i + 1}`,
        }
        this.menu.push(o)
      })
      this.menuIndex = this.$route.path
      // console.log(this.menuIndex)
      // console.log(this.menu)
    },
  },
  // watch: {
  //   $route(to, from) {
  //     // console.log(from, to)
  //   },
  // },
  mounted() {
    this.setRoute()
  },
};
</script>
